import api from './api';

export interface ParentChildDetail {
  id: number;
  first_name: string;
  last_name: string | null;
  class_group_name: string | null;
}

export interface Parent {
  id: number;
  first_name: string;
  last_name: string;
  phone_number: string;
  email: string | null;
  gender: 'M' | 'F' | null;
  children: number[];
  children_details: ParentChildDetail[];
  children_count: number;
  teacher: number;
  created_at: string;
  updated_at: string;
}

export interface ParentMessage {
  id: number;
  parent: number;
  sender_type: 'parent' | 'teacher';
  content: string;
  image: string | null;
  is_read: boolean;
  created_at: string;
}

export interface CreateParentData {
  first_name: string;
  last_name: string;
  phone_number: string;
  email?: string;
  gender?: 'M' | 'F';
  password?: string;
}

class ParentService {
  async getAll(): Promise<Parent[]> {
    const response = await api.get('/parents/');
    return response.data;
  }

  async getById(id: number): Promise<Parent> {
    const response = await api.get(`/parents/${id}/`);
    return response.data;
  }

  async create(data: CreateParentData): Promise<Parent> {
    const response = await api.post('/parents/', data);
    return response.data;
  }

  async update(id: number, data: Partial<CreateParentData>): Promise<Parent> {
    const response = await api.patch(`/parents/${id}/`, data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/parents/${id}/`);
  }

  async setPassword(id: number, password: string): Promise<void> {
    await api.post(`/parents/${id}/set_password/`, { password });
  }

  async linkChildren(id: number, childIds: number[]): Promise<void> {
    await api.post(`/parents/${id}/link_children/`, { children: childIds });
  }

  async getMessages(parentId: number): Promise<ParentMessage[]> {
    const response = await api.get(`/parents/${parentId}/messages/`);
    return response.data;
  }

  async sendMessage(parentId: number, content: string): Promise<ParentMessage> {
    const response = await api.post(`/parents/${parentId}/messages/`, { content });
    return response.data;
  }
}

export default new ParentService();
